import './TournamentInfo.css'
import { useTranslation } from 'react-i18next'
import { useState, useEffect, memo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { ReactComponent as Edition } from '../../icon/edit_blue.svg'
import { ReactComponent as Close } from '../../icon/close.svg'
import { TournamentForm } from '../TournamentForm/TournamentForm'
import { useRemoveTournamentMutation } from '../../redux/communityService/communityApiSlice'
import { GuestLink } from '../../components/GuestTournamentLink/GuestTournamentLink'

const TournamentInfoComponent = (props) => {
	const { t } = useTranslation()
	const [openedEdition, setOpenedEdition] = useState(false)
	const { tournamentUid, guestCode } = useParams()
	const [tournamentVenue, setTournamentVenue] = useState('')
	const navigate = useNavigate()
	const [removeTournamet] = useRemoveTournamentMutation()

	const closeEditorComponent = () => {
		setOpenedEdition(false)
	}

	const deleteTournamet = async () => {
		try {
			const response = await removeTournamet({ tournament_uid: tournamentUid }).unwrap()

			navigate(-1)
		} catch (e) {
			console.log('deleteTournamet catch error', e)
		}
	}

	useEffect(() => {
		if (Object.keys(props?.community).length !== 0) {
			// Получили категорию турнира
			//   const tournamentСategory = props?.community?.categories?.filter(category => {
			//     return category.uid === props?.tournament?.category_uid
			//   })
			//   setTournamentCategory({
			//     label: tournamentСategory[0]?.name,
			//     value: tournamentСategory[0]?.uid
			//   })

			// Получили место (адрес) турнира
			const tournamentVenues = props?.community?.venues?.find(venue => {
				return venue.uid === props?.tournament?.venue_uid
			})
			setTournamentVenue({
				label: tournamentVenues?.name,
				value: tournamentVenues?.uid,
				address_string: tournamentVenues?.address_string
			})
		} else {
			setTournamentVenue({ address_string: props?.tournament?.venue?.address_string })
		}
	}, [props?.tournament, props?.community])

	// Конвертер даты
	const convertDate = (sourceDate) => {
		// Разбиваем строку на компоненты (год, месяц, день)
		const components = sourceDate.split('-')

		// Преобразуем компоненты в формат "dd.mm.yyyy"
		const formattedDate = `${components[2]}.${components[1]}.${components[0]}`

		return formattedDate
	}

	console.log(props)

	return (
		<>
			<div className="tournament-info">
				{
					props?.auth && !openedEdition ?
						<GuestLink link={props?.guestUrl} />
						:
						null
				}

				<div className="tournament-info__header">
					<p className="tournament-info__header-title">
						{t('Information')}
					</p>

					{
						!openedEdition && props?.auth ?
							<div>
								<Edition
									className="tournament-info__header-edition"
									onClick={() => setOpenedEdition(true)}
								/>
							</div>
							:
							props?.auth ?
								<Close className="close-icon" onClick={() => setOpenedEdition(false)} />
								:
								''
					}
				</div>

				{
					openedEdition && props?.auth ?
						<TournamentForm
							header={false}
							openedEdition={openedEdition}
							tournament={props?.tournament}
							closeEditorComponent={closeEditorComponent}
							edit={true}
						/>
						:
						<div className="form-description__container">
							{
								tournamentVenue?.address_string ?
									<p className="form-description__text">
										{tournamentVenue?.address_string}
									</p>
									:
									null
							}

							<p className="form-description__text">
								<span className="form-description__bold">
									{ t('Start date') }:
								</span>

								<span> </span>

								{
									convertDate(props?.tournament?.start_date)
								}
							</p>

							{/*
							<p className="form-description__text">
								<span className="form-description__bold">
									{ t('Tournament category') }:
								</span>
								
								{
									tournamentCategory?.label ?
										tournamentCategory?.label
										:
										t('Category not selected')
								}
							</p>
							*/}

							<p className="form-description__text">
								<span className="form-description__bold">
									{ t('Tournament type') }:
								</span>

								<span> </span>

								{
									props?.tournament?.type === 'singles' ?
										t('Single')
										:
										props?.tournament?.type === 'doubles' &&
										t('Double')
								}
							</p>

							{/*
							<p className="form-description__text">
								<span className="form-description__bold">
									{ t('Floor') }:
								</span>
								
								{
									props?.tournament?.gender === 'men' ?
										t('Male')
										:
										props?.tournament?.gender === 'women' ?
											t('Female')
											:
											props?.tournament?.gender === 'mixed' &&
												t('Mix')
								}
							</p>
							*/}

							<p className="form-description__text">
								{
									props?.tournament?.description ?
										props?.tournament?.description
										:
										t('No description')
								}
							</p>

							<p className="form-description__text">
								<span className="form-description__bold">
									{ t('A method for determining places in a round-robin group when several participants have equal points') }:
								</span>

								<span> </span>

								{
									props?.tournament?.round_robin_ranking_system === 'group_sets_games_win_percentage' ?
										t('By the percentage of all sets/games won')
										:
										props?.tournament?.round_robin_ranking_system === 'equal_match_points_sets_games_win_percentage' &&
											t('By the percentage of sets/games won in games with each other')
								}
							</p>
						</div>
				}

				{
					props?.auth &&
					<div className="delete-tournamet__container">
						<button className="delete-tournamet__button" onClick={() => deleteTournamet()}>
							{ t('Remove tournament') }
						</button>
					</div>
				}
			</div>
		</>
	)
}

export const TournamentInfo = memo(TournamentInfoComponent)
